import styled from '@emotion/styled';
import TagV2 from '@zola/zola-ui/src/components/Tag/TagV2';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';

export const StyledTagV2 = styled(TagV2)`
  left: ${SPACING.XS};
  position: absolute;
  text-transform: none;
  top: ${SPACING.XS};
`;

export const ProductType = styled.div`
  color: ${COLORS3.BLACK_050};
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  margin-bottom: ${SPACING.XS};

  ${MEDIA_QUERY_V2.MOBILE} {
    font-size: ${FONT.FONT_SIZE_SMALLER};
  }
`;
